import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchProfile } from '@actions/profile';
import { getProfile, getProfileFetchError, getProfileIsFetching } from '@selectors/profile';

const useFetchProfile = () => {
    const dispatch = useDispatch();
    const profile = useSelector(getProfile);
    const isFetching = useSelector(getProfileIsFetching);
    const fetchError = useSelector(getProfileFetchError);

    useEffect(() => {
        dispatch(fetchProfile());
    }, [dispatch]);

    return { profile, isFetching, fetchError };
};

export default useFetchProfile;
